import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';

Vue.config.productionTip = false;

//global vars
Vue.prototype.$baseUrlApi = process.env.NODE_ENV === 'development' ? 'https://test.dvgapp.org' : 'https://api.dvgapp.org';
Vue.prototype.$androidAppUrl = 'https://play.google.com/store/apps/details?id=org.dvgapp.tourist';
Vue.prototype.$iOSAppUrl = 'https://apps.apple.com/us/app/id1518610159';
Vue.prototype.$pwaAppUrl = 'https://aruba.dvgapp.org/';

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
